export const types = [
    {
        name: "все",
        value: "all"
    },
    {
        name: "с ответами",
        value: "true"
    },
    {
        name: "без ответов",
        value: "false"
    },
]

export const grades = [
    {
        name: "все",
        value: "all"
    },
    {
        name: "1",
        value: "1"
    },
    {
        name: "2",
        value: "2"
    },
    {
        name: "3",
        value: "3"
    },
    {
        name: "4",
        value: "4"
    },
    {
        name: "5",
        value: "5"
    },
    {
        name: "6",
        value: "6"
    },
    {
        name: "7",
        value: "7"
    },
    {
        name: "8",
        value: "8"
    },
    {
        name: "9",
        value: "9"
    },
    {
        name: "10",
        value: "10"
    },
]

export const records = [
    {
        name: "все записи",
        value: "all"
    },
    {
        name: "к врачам",
        value: "true"
    },
    {
        name: "процедуры",
        value: "false"
    },
]

export const visitStatuses = [
    {
        name: "все",
        value: "all"
    },
    {
        name: "посетил",
        value: "true"
    },
    {
        name: "не посетил",
        value: "false"
    },
]

export const months = ['янв.', 'фев.', 'мар.', 'апр.', 'май.', 'июнь', 'июль', 'авг.', 'сен.', 'окт.', 'ноя.', 'дек.']
export const monthsFull = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']

export const for_child_objects = [
    {
        id: 0,
        name: "Только взрослых"
    },
    {
        id: 1,
        name: "Только детей"
    },
    {
        id: 2,
        name: "Взрослых и детей"
    },

]

export const child_ages = [
    {
        value: '0 мес.',
        name: "0 мес."
    },
    {
        value: '1 мес.',
        name: "1 мес."
    },
    {
        value: '2 мес.',
        name: "2 мес."
    },
    {
        value: '3 мес.',
        name: "3 мес."
    },
    {
        value: '4 мес.',
        name: "4 мес."
    },
    {
        value: '5 мес.',
        name: "5 мес."
    },
    {
        value: '6 мес.',
        name: "6 мес."
    },
    {
        value: '7 мес.',
        name: "7 мес."
    },
    {
        value: '8 мес.',
        name: "8 мес."
    },
    {
        value: '9 мес.',
        name: "9 мес."
    },
    {
        value: '10 мес.',
        name: "10 мес."
    },
    {
        value: '11 мес.',
        name: "11 мес."
    },
    {
        value: '1 год',
        name: "1 год"
    },
    {
        value: '2 года',
        name: "2 года"
    },
    {
        value: '3 года',
        name: "3 года"
    },
    {
        value: '4 года',
        name: "4 года"
    },
    {
        value: '5 лет',
        name: "5 лет"
    },
    {
        value: '6 лет',
        name: "6 лет"
    },
    {
        value: '7 лет',
        name: "7 лет"
    },
    {
        value: '8 лет',
        name: "8 лет"
    },
    {
        value: '9 лет',
        name: "9 лет"
    },
    {
        value: '10 лет',
        name: "10 лет"
    },
    {
        value: '11 лет',
        name: "11 лет"
    },
    {
        value: '12 лет',
        name: "12 лет"
    },
    {
        value: '13 лет',
        name: "13 лет"
    },
    {
        value: '14 лет',
        name: "14 лет"
    },
    {
        value: '15 лет',
        name: "15 лет"
    },
    {
        value: '16 лет',
        name: "16 лет"
    },
    {
        value: '17 лет',
        name: "17 лет"
    },
    {
        value: '18 лет',
        name: "18 лет"
    },
]

export const record_minutes = [
    {
        value: '10',
        name: "10"
    },
    {
        value: '15',
        name: "15"
    },
    {
        value: '20',
        name: "20"
    },
    {
        value: '25',
        name: "25"
    },
    {
        value: '30',
        name: "30"
    },
    {
        value: '40',
        name: "40"
    },
    {
        value: '45',
        name: "45"
    },
    {
        value: '50',
        name: "50"
    },
    {
        value: '60',
        name: "60"
    },

    {
        value: '90',
        name: "90"
    },

]

export const convertDate = (date: Date) => {
    let month = date.getMonth() + 1; //months from 1-12
    let day = date.getDate();
    let year = date.getFullYear();
    let dayString = day.toString()
    let monthString = month.toString()
    if (day < 10) {
        dayString = '0' + day.toString()
    }
    if (month < 10) {
        monthString = '0' + month.toString()
    }
    return `${year}-${monthString}-${dayString}`
}

export const getYearMonthFromDate = (date:string) =>{
    const newDate = new Date(date)
    return [monthsFull[newDate.getMonth()], newDate.getFullYear()]
}

export const getMonthYearFormat = (date:string) =>{
    const newDate = new Date(date)
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();
    let monthString = month.toString()
    if (month < 10) {
        monthString = '0' + month.toString()
    }
    return `${monthString}-${year}`
}